var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 200 200",
    className: "fill",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.277 0V17.2352H99.7244V0H100.277Z",
    className: "fill",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.277 182.765V200H99.7244V182.765H100.277Z",
    className: "fill",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200 99.7243V100.277H182.765V99.7243H200Z",
    className: "fill",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2352 99.7243V100.277H0V99.7243H17.2352Z",
    className: "fill",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.563 49.9275L186.837 50.4062L171.894 58.9948L171.62 58.5161L186.563 49.9275V49.9275Z",
    className: "fill",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1057 141L28.3803 141.479L13.4373 150.067L13.1627 149.588L28.1057 141Z",
    className: "fill",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.553 13.143L150.032 13.4176L141.451 28.3648L140.971 28.0891L149.553 13.143V13.143Z",
    className: "fill",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5461 171.638L59.0259 171.914L50.4435 186.86L49.9647 186.585L58.5461 171.638V171.638Z",
    className: "fill",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1513 13.3078L58.7845 28.2249L58.3067 28.5016L49.6736 13.5845L50.1513 13.3078Z",
    className: "fill",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.695 171.488L150.327 186.405L149.851 186.682L141.217 171.765L141.695 171.488Z",
    className: "fill",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3575 50.0694L28.314 58.6332L28.0394 59.1129L13.0829 50.5482L13.3575 50.0694Z",
    className: "fill",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.959 140.885L186.915 149.449L186.641 149.929L171.684 141.364L171.959 140.885V140.885Z",
    className: "fill",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 100,
    cy: 100,
    className: "fill",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 100,
    y2: 64,
    strokeWidth: 2,
    className: "stroke",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 100,
    y2: 44,
    strokeWidth: 1,
    className: "stroke",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 100,
    y2: 24,
    strokeWidth: 0.5,
    className: "stroke",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.65c186c198a51a62e267d7bdef2a0e42.svg";
export { ForwardRef as ReactComponent };